<section>
    <div class="container">
        <div class="row wrapper-row">
            <div class="col-sm col-img">
                <div class="hr-line"></div>
                <img class="img-dots" src="/assets/img/01.svg">
                <img class="img-portrait" src="/assets/img/02.jpg">
            </div>
            <div class="col-sm col-text">
                <div class="hr-line"></div>
                <div class="content">
                    <h2 class="h-large">{{ 'hp.about.us.lbl.001' | translate }}<br>{{ 'hp.about.us.lbl.002' | translate }}</h2>
                    <p>{{ 'hp.about.us.lbl.003' | translate }}</p>
                    <!-- <a class="w-btn rounded-btn" routerLink="medius/about-us"> -->
                    <a class="w-btn rounded-btn" routerLink="/medius/gf-technology">
                        <span>{{ 'hp.about.us.lbl.004' | translate }}</span>
                        <div></div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>